export const noAvatarImg = 'https://diora.pro/assets/img/staff/kontakt.jpg'
export const backgroundImg = 'https://i.pinimg.com/originals/d4/79/35/d479359444438e53a87e3fcd7a752b0e.png'
